var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"facebook d-flex align-items-center",attrs:{"href":"https://www.facebook.com/touriDat","target":_vm.target}},[_c('font-awesome-icon',{attrs:{"icon":"fa-brands fa-facebook"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }